export default "__VITE_ASSET__D7opV11m__"